<section class="privacy-policy">
  <div class="container">
    <header class="privacy-header">
      <h1>orderYaa ERP Subscription Agreement</h1>
      <p class="last-updated">Last updated: {{ lastUpdated }}</p>
    </header>

    <div class="privacy-content">
      <p>
        This Subscription Agreement ("Agreement") is entered into between Tech Colleagues
        ("orderYaa", "we", "us", or "our") and the customer registering for or using the orderYaa
        ERP platform (the "Customer", "you", or "your"). By creating an account, selecting apps
        during onboarding, or otherwise using the Services, you agree to be bound by this
        Agreement.
      </p>

      <h2>1. Term of the Agreement</h2>
      <p>
        This Agreement begins on the date you first create an orderYaa account and continues for
        as long as your account remains active. Either party may terminate this Agreement as
        described in Section 8 (Termination).
      </p>

      <h2>2. Definitions</h2>
      <ul>
        <li><strong>"Services"</strong> means the orderYaa ERP platform, including all modules and apps made available through your account (e.g. Sales, CRM, HR, Inventory, Accounting, Procurement, Manufacturing).</li>
        <li><strong>"User"</strong> means any individual authorized by the Customer to access the Services under the Customer's account.</li>
        <li><strong>"Customer Data"</strong> means any data, records, or content that the Customer or its Users submit to the Services.</li>
      </ul>

      <h2>3. Access to the Services</h2>
      <p>
        Subject to this Agreement, we grant the Customer a non-exclusive, non-transferable right
        to access and use the Services during the Term, solely for the Customer's internal
        business operations. Access is provided on a self-service basis; the Customer chooses
        which modules to enable during onboarding and may add or remove modules at any time from
        account settings.
      </p>

      <h2>4. Fees and Free Access</h2>
      <p>
        Core onboarding and the modules selected during the "Choose your Apps" step are provided
        free of charge, with unlimited users, for as long as your account remains active on that
        plan. Optional paid plans, add-ons, or premium modules (if any) will always show their
        price clearly before you are charged, and no payment method is required to start a free
        account.
      </p>

      <h2>5. Conditions of Service</h2>
      <p>The Customer agrees to:</p>
      <ul>
        <li>Provide accurate registration information and keep it up to date.</li>
        <li>Be responsible for all activity that occurs under its account and Users' credentials.</li>
        <li>Use the Services in compliance with applicable laws and not to store or transmit unlawful, infringing, or harmful content.</li>
        <li>Not attempt to reverse-engineer, resell, or disrupt the Services except as expressly permitted.</li>
      </ul>

      <h2>6. Customer Data</h2>
      <p>
        The Customer retains all rights to its Customer Data. We process Customer Data only to
        provide, secure, and support the Services, as described in our
        <a href="/privacy-policy">Privacy Policy</a>. The Customer may export or request
        deletion of its Customer Data at any time, subject to legal and accounting retention
        requirements.
      </p>

      <h2>7. Warranties and Disclaimers</h2>
      <p>
        We will use commercially reasonable efforts to make the Services available and to perform
        them in a professional manner consistent with industry standards. Except as expressly
        stated in this Agreement, the Services are provided "as is", and we disclaim all other
        warranties, whether express or implied, to the maximum extent permitted by law.
      </p>

      <h2>8. Termination</h2>
      <p>
        The Customer may stop using the Services and close its account at any time. We may
        suspend or terminate access if the Customer materially breaches this Agreement and does
        not remedy the breach within a reasonable period after notice. Upon termination, the
        Customer's right to access the Services ends, and Customer Data will be handled in
        accordance with our data retention practices described in the Privacy Policy.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, neither party will be liable to the other for any
        indirect, incidental, special, or consequential damages arising out of or related to this
        Agreement, even if advised of the possibility of such damages.
      </p>

      <h2>10. General Provisions</h2>
      <ul>
        <li><strong>Changes to this Agreement:</strong> We may update this Agreement from time to time. Material changes will update the "Last updated" date above, and continued use of the Services after changes take effect constitutes acceptance.</li>
        <li><strong>Entire Agreement:</strong> This Agreement, together with the Privacy Policy, constitutes the entire agreement between the parties regarding the Services.</li>
        <li><strong>Assignment:</strong> The Customer may not assign this Agreement without our prior written consent.</li>
      </ul>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions about this Subscription Agreement, please contact us:
      </p>
      <ul class="contact-list">
        <li><strong>Company:</strong> Tech Colleagues</li>
        <li><strong>Product:</strong> orderYaa ERP</li>
        <li><strong>Email:</strong> <a href="mailto:hr@techcolleagues.com">hr@techcolleagues.com</a></li>
      </ul>

      <p class="footnote">
        This is a general template agreement provided for onboarding purposes and should be
        reviewed by legal counsel before being relied upon as a binding commercial contract.
      </p>
    </div>
  </div>
</section>
